const MENTION_HREF_PATH_PREFIX = '/__mention__/user/'
const UUID_REGEX_PART =
  '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}'

const MENTION_HREF_REGEX = new RegExp(
  `${MENTION_HREF_PATH_PREFIX}(${UUID_REGEX_PART})`,
  'g',
)
const MENTION_HREF_SINGLE_REGEX = new RegExp(
  `${MENTION_HREF_PATH_PREFIX}(${UUID_REGEX_PART})`,
)

export function buildMentionHref(userId: string, origin?: string): string {
  const safeId = String(userId || '').trim()
  const base =
    origin ||
    (typeof window !== 'undefined' && window?.location?.origin
      ? window.location.origin
      : '')
  return `${base}${MENTION_HREF_PATH_PREFIX}${encodeURIComponent(safeId)}`
}

export function isMentionHref(href: string): boolean {
  const raw = String(href || '')
  return raw.includes(MENTION_HREF_PATH_PREFIX) && new RegExp(UUID_REGEX_PART).test(raw)
}

export function extractMentionUserIdFromHref(href: string): string | null {
  const raw = String(href || '').trim()
  if (!raw) return null
  const match = raw.match(MENTION_HREF_SINGLE_REGEX)
  const id = String(match?.[1] || '').trim()
  return id || null
}

export function normalizeMentionDisplayName(fullName?: string | null): string {
  const raw = String(fullName || '').trim()
  const cleaned = raw.replace(/^@+/, '').replace(/\s+/g, ' ').trim()
  return cleaned || 'Usuário'
}

export function extractMentionUserIdsFromHtml(html: string): string[] {
  const raw = String(html || '')
  if (!raw) return []

  const ids = new Set<string>()
  const matches = raw.matchAll(MENTION_HREF_REGEX)
  for (const m of matches) {
    const id = String(m?.[1] || '').trim()
    if (id) ids.add(id)
  }
  return Array.from(ids)
}
